module.exports = __webpack_public_path__ + "img/subject-bg.8364cd29.svg";